import { Link } from "react-router-dom";
import { PageBanner } from "@/shared/components/PageBanner";

export function MarketplaceHomePage() {
  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="مارکت‌پلیس"
        subtitle="مدیریت آگهی‌ها (Listing) و سفارش‌های تبادلی (OrderExchange)."
        icon="🛍️"
        helpLink="/help/marketplace"
      />
      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: "1rem" }}>
          <li>
            <Link to="/marketplace/listings" style={{ display: "inline-block", padding: "0.75rem 1.5rem", background: "rgba(255,255,255,0.05)", borderRadius: "8px", textDecoration: "none", color: "var(--color-primary-light)", border: "1px solid var(--glass-border)", width: "200px", textAlign: "center" }}>
              آگهی‌ها
            </Link>
          </li>
          <li>
            <Link to="/marketplace/orders" style={{ display: "inline-block", padding: "0.75rem 1.5rem", background: "rgba(255,255,255,0.05)", borderRadius: "8px", textDecoration: "none", color: "var(--color-primary-light)", border: "1px solid var(--glass-border)", width: "200px", textAlign: "center" }}>
              سفارش‌ها
            </Link>
          </li>
          <li>
            <Link to="/marketplace/stores" style={{ display: "inline-block", padding: "0.75rem 1.5rem", background: "rgba(255,255,255,0.05)", borderRadius: "8px", textDecoration: "none", color: "var(--color-primary-light)", border: "1px solid var(--glass-border)", width: "200px", textAlign: "center" }}>
              فروشگاه‌ها
            </Link>
          </li>
          <li>
            <Link to="/marketplace/catalog" style={{ display: "inline-block", padding: "0.75rem 1.5rem", background: "rgba(255,255,255,0.05)", borderRadius: "8px", textDecoration: "none", color: "var(--color-primary-light)", border: "1px solid var(--glass-border)", width: "200px", textAlign: "center" }}>
              کاتالوگ‌ها
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
